<template>
  <div class="Melamine">
    <div class="title">Melamine</div>
    <div class="item">
      <label>Specificatoins:</label>
      <p>Grade Standard:Industrial Grade</p>
    </div>
    <div>
      <el-table border style="width: 500px" :data="tableData" stripe>
        <el-table-column prop="appearance" label="Appearance">
        </el-table-column>
        <el-table-column prop="WhitePower" label="White power">
        </el-table-column>
      </el-table>
    </div>
    <div class="item">
      <label>Package:</label>
      <p>25kg/500kg/1000kg/bag,20mt per 20FCL</p>
    </div>
    <div class="item-huanhang">
      <label>Mainly Applications:</label>
      <p>
        Melamine is combined with formaldehyde and other agents to produce
        melamine resins. Such resins are characteristically durable
        thermosetting plastic used inhigh-pressure decorative laminates such as
        Formica, melamine dinnerware, laminate flooring, and dry erase boards.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Melamine",
  data() {
    return {
      tableData: [
        { appearance: "Purity", WhitePower: "99.8%min" },
        { appearance: "Mositure", WhitePower: "0.03%max" },
        { appearance: "Ash content", WhitePower: "0.1%max" },
        { appearance: "Ph value", WhitePower: "7.9-9.5" },
        { appearance: "Turbidity(kaolin)", WhitePower: "20max" },
        { appearance: "Color haze", WhitePower: "20max" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  .title {
    font-size: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    color: #042a42cf;
  }
  .item {
    display: flex;
    height: 40px;
    line-height: 40px;
    column-gap: 20px;
    label {
      font-size: 20px;
      font-weight: bold;
    }
    p {
      color:gray;
      font-weight: bold;
    }
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
    label {
      
      line-height: 40px;
      font-size: 20px;
      font-weight: bold;
    }
    p {
      color:gray;
      line-height: 30px;
      font-weight: bold;
    }
  }
}
</style>
